"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CircularIterator_1 = require("./CircularIterator");
class CircularStream {
    constructor(values) {
        this.values = values;
        this.it = CircularIterator_1.default.of(values);
    }
    static of(values) {
        return new CircularStream(values);
    }
    filter(filter) {
        this.it = CircularIterator_1.default.of(this.it.getValues().filter(filter));
        return this;
    }
    map(map) {
        return CircularStream.of(this.it.getValues().map(map));
    }
    limit(size) {
        let values = [];
        while (size-- > 0) {
            values.push(this.it.next().value);
        }
        return values;
    }
    skip(amount) {
        while (amount-- > 0) {
            this.it.next();
        }
        return this;
    }
}
exports.default = CircularStream;
